import LeaseQualificationAccordion from './LeaseQualificationAccordion';
export default LeaseQualificationAccordion;
